export function replaceAmount(format, price='') {
    console.log(format, price);
    const formats = {
      // 1,134.65
      '{{amount}}': price.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
      }),
  
      // 1,135
      '{{amount_no_decimals}}': Math.round(price).toLocaleString('en-US', {
        maximumFractionDigits: 0,
        useGrouping: true,
      }),
  
      // 1.134,65 (European style)
      '{{amount_with_comma_separator}}': price.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
      }),
  
      // 1.135
      '{{amount_no_decimals_with_comma_separator}}': Math.round(
        price
      ).toLocaleString('de-DE', {
        maximumFractionDigits: 0,
        useGrouping: true,
      }),
  
      // 1'134.65 (Swiss French style)
      '{{amount_with_apostrophe_separator}}': price
        .toLocaleString('fr-CH', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: true,
        })
        .replace(/\s/g, "'"),
  
      // 1 135 (French with space separator, no decimals)
      '{{amount_no_decimals_with_space_separator}}': Math.round(
        price
      ).toLocaleString('fr-FR', {
        maximumFractionDigits: 0,
        useGrouping: true,
      }),
  
      // 1 134,65 (French with space separator and decimals)
      '{{amount_with_space_separator}}': price.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
      }),
  
      // 1 134.65 (space separator, US-style dot)
      '{{amount_with_period_and_space_separator}}': price
        .toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          useGrouping: true,
        })
        .replace(/,/g, ' '),
    }
  
    return format.replace(
      /\{\{\s*(amount.*?)\s*\}\}/g,
      (match, key) => formats[`{{${key}}}`] || match
    )
  }